import React, { Component } from 'react';
import Onboarding from '../components/tour/Onboarding';
import River from '../components/tour/river/River';
import DetailViewer from '../components/tour/details/DetailViewer';
import Map from '../components/tour/map/Map';
import styles from './Tour.module.scss';
import Transitioner from '../components/utils/Transitioner';
import Helmet from 'react-helmet';

//selection enums
const LOCATION = 'location';
const TAP = 'tap';

//it begins
class Tour extends Component {
  state = {
    activeStop: undefined, //this.props.data.details.tour_stops[0]
    firstStopLoaded: false,
    visitedStopIds: [], //[this.props.data.markers.tour_stops[0].id]
    activeDetailType: '',
    stopSelectionMethod: '',
    activeDetail: undefined,
    tourStopSelectionMethod: '',
    hasBeenOnboarded: false,
    onboardingStatus: 'beforeEnter',
    isMobileDevice: false,
    isDetailViewerOpen: false,
    isSlideshowDetailOpen: false,
    isTransitioningBetweenStops: false,
  };

  handleCheckForMobileDevice = () => {
    if (typeof window !== 'undefined') {
      let mq = parseInt(styles.mobileBreakPoint.replace('px', ''), 10);
      if (window.innerWidth < mq) {
        this.setState({
          isMobileDevice: true,
        });
      } else {
        this.setState({
          isMobileDevice: false,
        });
      }
    }
  };

  handleTourStopDetailClosed = () => {
    this.setState({
      activeDetailType: '',
      activeDetail: undefined,
      isDetailViewerOpen: false,
      isSlideshowDetailOpen: false,
    });
  };

  handleTourStopDetailOpened = detail => {
    const { detail_type } = detail;
    if (
      this.state.activeDetail &&
      detail.title === this.state.activeDetail.title
    ) {
      this.handleTourStopDetailClosed();
    } else {
      this.setState({
        activeDetailType: detail_type,
        activeDetail: detail,
        isSlideshowDetailOpen: detail_type === 'slideshow' ? true : false,
        isDetailViewerOpen:
          detail_type === 'press_and_hold' || detail_type === 'video'
            ? true
            : false,
      });
    }
  };

  handleIsTransitioningBetweenStops = transitioning => {
    this.setState({
      isTransitioningBetweenStops: transitioning,
    });
  };

  handleSetSelectionMethod = method => {
    this.setState({
      stopSelectionMethod: method,
    });
  };

  handleOpenTourStopByDistance = id => {
    this.handleMarkerClicked(null, id, false);
  };

  //Handle clicking the marker
  handleMarkerClicked = (e, id, tap = true) => {
    if (this.state.isTransitioningBetweenStops) return;
    this.handleMarkerSelected(id, tap);
  };

  handleMarkerSelected = (id, tap) => {
    const { tour_stops } = this.props.data.details;
    this.handleTourStopDetailClosed();

    this.setState({
      stopSelectionMethod: tap ? TAP : LOCATION,
      isTransitioningBetweenStops: true,
      firstStopLoaded:
        this.state.firstStopLoaded === false
          ? true
          : this.state.firstStopLoaded,
      activeStop: id
        ? tour_stops.find(stop => parseInt(stop.id) === parseInt(id))
        : this.state.activeStop,
      visitedStopIds: [...this.state.visitedStopIds, id],
    });
  };

  handleEnterFromOnboarding = e => {
    this.setState(
      {
        onboardingStatus: 'exit',
      },
      () => {
        setTimeout(() => {
          this.setState(
            { hasBeenOnboarded: true },
            this.props.setMainMenuColor('black'),
            this.props.setLogoColor('black')
          );
        }, 600);
      }
    );
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ onboardingStatus: 'active' });
    }, 200);

    this.handleCheckForMobileDevice();
    this.props.setMainMenuColor('white');
    this.props.setLogoColor('white');
    this.props.setHeaderGradient(false);
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleCheckForMobileDevice);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleCheckForMobileDevice);
    }
  }

  render() {
    const { markers, details } = this.props.data;
    const {
      activeDetail,
      activeStop,
      firstStopLoaded,
      visitedStopIds,
      hasBeenOnboarded,
      isDetailViewerOpen,
      isSlideshowDetailOpen,
    } = this.state;

    return (
      <div style={{ overflow: 'hidden', height: '100%', position: 'relative' }}>
        <Helmet title={`Walking Tour | The House on Henry Street`} />

        {this.state.hasBeenOnboarded &&
          firstStopLoaded && (
            <River
              isSlideshowDetailOpen={isSlideshowDetailOpen}
              isMobileDevice={this.state.isMobileDevice}
              setActiveDetail={this.handleTourStopDetailOpened}
              handleTourStopDetailClosed={this.handleTourStopDetailClosed}
              activeDetail={activeDetail}
              activeStop={activeStop}
              setIsTransitioningBetweenStops={
                this.handleIsTransitioningBetweenStops
              }
            />
          )}
        <Transitioner
          isActive={isDetailViewerOpen}
          timeout={1500}
          classNames="slideUp"
        >
          <DetailViewer
            isOpen={isDetailViewerOpen}
            closeActiveDetail={this.handleTourStopDetailOpened}
            parentProps={{ ...this.props }}
            detail={{ ...activeDetail }}
          />
        </Transitioner>
        <Map
          hasBeenOnboarded={hasBeenOnboarded}
          isMobileDevice={this.state.isMobileDevice}
          handleMarkerClicked={this.handleMarkerClicked}
          stopSelectionMethod={this.state.stopSelectionMethod}
          handleSetSelectionMethod={this.handleSetSelectionMethod}
          handleOpenTourStopByDistance={this.handleOpenTourStopByDistance}
          markers={markers.tour_stops}
          activeStopId={activeStop !== undefined ? activeStop.id : -1}
          visitedStopIds={visitedStopIds}
          firstStopLoaded={firstStopLoaded}
          isTransitioningBetweenStops={this.state.isTransitioningBetweenStops}
        />
        {!hasBeenOnboarded && (
          <Onboarding
            isMobileDevice={this.state.isMobileDevice}
            handleEnterFromOnboarding={this.handleEnterFromOnboarding}
            status={this.state.onboardingStatus}
          />
        )}
      </div>
    );
  }
}

export default Tour;

export const tourQuery = graphql`
  query tourstopMarkerDataAndTourStopContent($path: String!) {
    details: dataJson(path: { eq: $path }) {
      tour_stops {
        title
        id
        body
        tour_stop_type
        image {
          alt
          url
          sizes {
            large
          }
        }
        details {
          detail_type
          quote_text
          caption
          title
          body
          label
          watermark
          vimeo_id
          youtube_id
          video_source
          video_file {
            url
          }
          poster {
            alt
            sizes {
              #medium
              medium_large
            }
          }
          slides {
            body
            body_quadrant
            image {
              url
              alt
            }
            image_portrait {
              url
              alt
            }
            source {
              landscape {
                url
              }
              portrait {
                url
              }
            }
            poster {
              portrait {
                url
                alt
              }
              landscape {
                url
                alt
              }
            }
          }
          audio_file {
            url
            title
          }
          image {
            url
            alt
            sizes {
              large
            }
          }
          images {
            url
            alt
            width
            height
            sizes {
              large
            }
            description
            caption
          }
        }
      }
    }
    markers: dataJson(path: { eq: $path }) {
      tour_stops {
        title
        id
        tour_stop_type
        map_data {
          address
          lat
          lng
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/tour.js